// Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material/material.module';
import { PrimeModule } from './primeNG/prime.module';
import { HighchartsChartModule } from 'highcharts-angular';
import { NgxPopperjsModule } from 'ngx-popperjs';
// Directives
import { DateInputConverter } from './forms/date-input/date-input.directive';
import { FocusableDirective } from './forms/focasable/focasable.directive';
import { PermissionWrapperComponent } from './permission-wrapper/permission-wrapper.component';
import { EditableOnEnterDirective } from './forms/edit-in-place/edit-on-enter.directive';
import { EditInPlaceEditDirective } from './forms/edit-in-place/edit-in-place-edit.directive';
import { EditInPlaceViewDirective } from './forms/edit-in-place/edit-in-place-view.directive';
import { ClosedByDefaultDirective } from './closed-by-default/closed-by-default.directive';
import { DynamicComponentHostDirective } from './dynamic-component-loader/dynamic-component-host.directive';
// Components
import { SearchComponent } from './search/search.component';
import { DynamicComponentLoader } from './dynamic-component-loader/dynamic-component-loader.component';
import { IconComponent } from './icon/icon.component';
import { LargeSpinnerComponent } from './spinner/app-spinner.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { DiffBarComponent } from './diff-bar/diff-bar.component';
import { MultiBarComponent } from './multi-bar/multi-bar.component';
import { SearchPortfolioComponent } from './search/search-portfolio/search-portfolio.component';
import { SearchClientComponent } from './search/search-client/search-client.component';
import { SearchSecurityComponent } from './search/search-security/search-security.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { EditInPlaceComponent } from './forms/edit-in-place/edit-in-place.component';
import { CumulativeReturnsChartComponent } from '../features/client/performance/cumulative-returns-chart/cumulative-returns-chart.component';
import { ComponentErrorComponent } from '../error/component-error/component-error.component';
import { DrillDownComponent } from './drill-down/drill-down.component';
import { FooterComponent } from '../footer/footer.component';
import { DrillDownResolveBaseComponent } from './drill-down/drill-down-resolve-base.component';
import { DatePeriodSelectorComponent } from './date-period-selector/date-period-selector.component';
import { FixedElementComponent } from './fixed-element/fixed-element.component';
import { DynamicComponentModal } from 'src/app/components/shared/dynamic-component-modal/dynamic-component-modal.component';
import { MuliSelectSearchComponent } from './search/muli-select-search/muli-select-search.component';
import { AmountDisplayComponent } from './amount-display/amount-display.component';
import { CurrencyComponent } from './currency/currency.component';
import { BadgeResultComponent } from './badge-result/badge-result.component';
import { SortableComponent } from './sortable/sortable.component';
import { BreakdownComponent } from './breakdown/breakdown.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { CustomNumberComponent } from './custom-number/custom-number.component';
import { AutocompletionComponent } from './autocompletion/autocompletion.component';
import { NotificationMessageComponent } from './notification-message/notification-message.component';
import { PopoverComponent } from './popover/popover.component';
import { ProgressBarComponent } from './progressbar/progress-bar.component';
import { IconsModule } from "./icon/icons.module";
import { AvailableCashComponent } from "./available-cash/available-cash.component";
import { ConfirmationDrilldownComponent } from './confirmation-drilldown/confirmation-drilldown.component';
import { DragAndDropDirective } from './drag-drop/drag-drop.directive';
import { FileUploadComponent } from './file-upload/file-upload.component';

@NgModule({
  imports: [
    CommonModule,
    PrimeModule,
    MaterialModule,
    ReactiveFormsModule,
    HighchartsChartModule,
    NgxPopperjsModule.forRoot({
      applyClass: "popper_tooltip",
      applyArrowClass: "popper_arrow"
    }),
    IconsModule,
  ],
  declarations: [
    EditInPlaceViewDirective,
    EditInPlaceEditDirective,
    EditableOnEnterDirective,
    FocusableDirective,
    DynamicComponentHostDirective,
    ClosedByDefaultDirective,
    DateInputConverter,
    LargeSpinnerComponent,
    SpinnerComponent,
    DiffBarComponent,
    MultiBarComponent,
    SearchClientComponent,
    SearchPortfolioComponent,
    SearchComponent,
    SearchSecurityComponent,
    TooltipComponent,
    DatePeriodSelectorComponent,
    IconComponent,
    EditInPlaceComponent,
    DynamicComponentLoader,
    DynamicComponentModal,
    PermissionWrapperComponent,
    DrillDownComponent,
    DrillDownResolveBaseComponent,
    FooterComponent,
    CumulativeReturnsChartComponent,
    ComponentErrorComponent,
    FooterComponent,
    FixedElementComponent,
    MuliSelectSearchComponent,
    AmountDisplayComponent,
    CurrencyComponent,
    BadgeResultComponent,
    SortableComponent,
    BreakdownComponent,
    DatepickerComponent,
    CustomNumberComponent,
    AutocompletionComponent,
    NotificationMessageComponent,
    PopoverComponent,
    ProgressBarComponent,
    AvailableCashComponent,
    ProgressBarComponent,
    ConfirmationDrilldownComponent,
    DragAndDropDirective,
    FileUploadComponent,
  ],
  exports: [
    ReactiveFormsModule,
    MaterialModule,
    PrimeModule,
    NgxPopperjsModule,
    EditInPlaceViewDirective,
    EditInPlaceEditDirective,
    EditableOnEnterDirective,
    FocusableDirective,
    DynamicComponentHostDirective,
    ClosedByDefaultDirective,
    DateInputConverter,
    LargeSpinnerComponent,
    SpinnerComponent,
    DiffBarComponent,
    MultiBarComponent,
    SearchComponent,
    SearchClientComponent,
    SearchPortfolioComponent,
    SearchSecurityComponent,
    TooltipComponent,
    DatePeriodSelectorComponent,
    IconComponent,
    EditInPlaceComponent,
    FooterComponent,
    CumulativeReturnsChartComponent,
    ComponentErrorComponent,
    DynamicComponentLoader,
    DynamicComponentModal,
    PermissionWrapperComponent,
    DrillDownComponent,
    DrillDownResolveBaseComponent,
    FixedElementComponent,
    MuliSelectSearchComponent,
    AmountDisplayComponent,
    CurrencyComponent,
    BadgeResultComponent,
    SortableComponent,
    BreakdownComponent,
    DatepickerComponent,
    CustomNumberComponent,
    AutocompletionComponent,
    NotificationMessageComponent,
    PopoverComponent,
    ProgressBarComponent,
    IconsModule,
    AvailableCashComponent,
    IconsModule,
    ConfirmationDrilldownComponent,
    DragAndDropDirective,
    FileUploadComponent,
  ]
})
export class AdminisSharedModule {}
